var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6H5V7.5H19V6ZM19 11.25H5V12.75H19V11.25ZM5 16.5H19V18H5V16.5Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Menu_Icon.518da8011a9a2829f4fbeb3e7d7d1847.svg";